import {
  IconButton,
  IconColor,
  IconName,
  IconSize
} from '@focaldata/cin-ui-components'
import React, { useContext } from 'react'
import useGetDraftQuestionnaire from '../../../hooks/questionnaire/useGetDraftQuestionnaire'
import QuestionnaireContext, {
  openPreviewPanel
} from '../Questionnaire.context'
import useStyles from './PreviewButtonAbsolute.styles'

const PreviewButtonAbsolute: React.FC = () => {
  const { questionnaireState, dispatch } = useContext(QuestionnaireContext)
  const { draftQuestionnaire } = useGetDraftQuestionnaire()
  const entryCount = draftQuestionnaire?.entries.length ?? 0
  const { classes, cx: classNames } = useStyles()
  if (entryCount === 0) {
    return null
  }
  return (
    <div
      className={classNames(
        'fd-grid fd-container fd-justify-content-flex-end',
        classes.root
      )}
    >
      {!questionnaireState.isPreviewPanelOpened && (
        <div
          className={classNames('fd-grid fd-item fd-xs-auto', classes.button)}
        >
          <IconButton
            onClick={() => {
              dispatch(openPreviewPanel())
            }}
            iconName={IconName.PlayCircleOutline}
            iconSize={IconSize.Large}
            iconColor={IconColor.Emphasis}
          />
        </div>
      )}
    </div>
  )
}

export default PreviewButtonAbsolute
